import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector<HTMLElement>(
    '[data-top-movie-swiper]'
  );

  if (swiperElement) {
    new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 16,
      loop: false,
      // autoplay: {
      //   delay: 3000,
      // },
      speed: 3000,
      navigation: {
        nextEl: '[data-top-movie-swiper-next]',
        prevEl: '[data-top-movie-swiper-prev]',
      },
      pagination: {
        el: '[data-data-top-movie-swiper-pagination]',
        type: 'bullets',
        clickable: true,
        bulletClass: 'global-swiper-pagination__bullet',
        bulletActiveClass: 'global-swiper-pagination__bullet--active',
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    });
  }
});
